import { MICROSERVICES } from '@shared/constants/microservices';

interface MockPathRule {
    path: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
    headers: string[];
    xAppId?: string;
    delay?: number;
}

interface MockRule {
    serviceKey: keyof typeof MICROSERVICES;
    paths: MockPathRule[];
}

export const MOCK_RULES: MockRule[] = [
    {
        serviceKey: 'ruc_vehicles',
        paths: [
            // { path: '/vehicles', method: 'GET', headers: ['example=multiple_pages', 'example=multiple_pages2'], delay: 500 },
            // { path: '/vehicles', method: 'POST', headers: ['example=two_models'] },
            // { path: '/vehicles/:id', method: 'PATCH', headers: ['example=select_vehicle_model'] },
            // { path: '/vehicles/:id', method: 'GET', headers: ['example=invalid_denial_request_code'] },
            // { path: '/vehicles/:id', method: 'GET', headers: ['example=denied_dmv-multiple'] },
            // { path: '/vehicles/:id', method: 'GET', headers: ['example=denied_dmv-undefined'] },
        ],
    },
    {
        serviceKey: 'payments',
        paths: [
            // { path: '/payment_methods', method: 'GET', headers: ['example=multiples_payment_methods'] },
            // { path: '/payment_methods', method: 'GET', headers: ['code=500'] },
        ],
    },
    {
        serviceKey: 'mro_smartcar',
        paths: [
            // { path: '/smartcar-vehicles/compatibility', method: 'GET', headers: ['example=compatible'] },
        ],
    },
    {
        serviceKey: 'accounts',
        paths: [
            // { path: '/user', method: 'GET', headers: ['example=uncollectible'] }
        ],
    },
    {
        serviceKey: 'mro_manual',
        paths: [
            // { path: '/vehicles/:id/miles-readings', method: 'POST', headers: ['code=201'] },
        ],
    },
];

export type { MockPathRule, MockRule };
